import { ColumnsCount } from './types';

export const getColumnCount = ({
  columnsCount,
  width,
}: {
  columnsCount: ColumnsCount;
  width: number;
}) => {
  if (width < 500) {
    return columnsCount.Small;
  }
  if (width < 800) {
    return columnsCount.Medium;
  }
  if (width < 1200) {
    return columnsCount.Large;
  }
  return columnsCount.ExtraLarge;
};
